import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SearchIcon from "@mui/icons-material/Search";

import CustomTable from "../../../components/CustomTable";
import { filterList } from "../../../libs/utils";
import {
  getAllBonusActivities,
  updateCampaignStatus,
} from "../../../services/timesPoint/bonusCampaign";

const BonusCampaignList = () => {
  const [rows, setRows] = useState();
  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");

  const columns = [
    {
      id: "campaignName",
      label: "Title",
      minWidth: 100,
      sortable: true,
      align: "left",
      enableSort: true,
    },
    {
      id: "ctype",
      label: "Campaign Type",
      minWidth: 100,
      sortable: true,
      align: "left",
      enableSort: true,
    },
    {
      id: "bonusAct",
      label: "Bonus Activity",
      minWidth: 100,
      sortable: true,
      align: "left",
      enableSort: true,
    },
    {
      id: "active",
      label: "Active",
      minWidth: 100,
      sortable: true,
      align: "left",
      enableSort: false,
    },
    {
      id: "Action",
      label: "Action",
      minWidth: 100,
      align: "left",
    },
  ];

  const searchData = (e) => {
    setSearchKey(e.target.value);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeStatus = async (id, active) => {
    setLoading(true);
    const activeStatus = active;
    const updateCampaignStatusRes = await updateCampaignStatus({
      campaignId: id,
      active: !activeStatus,
    });
    const { status, message } = updateCampaignStatusRes || {};
    setLoading(false);
    if (status === "SUCCESS") {
      fetchbonusCampaigns();
      Swal.fire({
        title: "Success",
        text: message,
        icon: "success",
        confirmButtonText: "Ok",
      });
      return;
    }
    Swal.fire({
      title: "Oops",
      text: message,
      icon: "warning",
      confirmButtonText: "Ok",
    });
  };

  const dataGenerator = (campaign) => {
    const { id: campaignId, active } = campaign;
    return {
      ...campaign,
      active: active ? "Yes" : "No",
      Action: (
        <Button
          variant="contained"
          size="small"
          color="warning"
          onClick={() => handleChangeStatus(campaignId, active)}
        >
          {`${active ? "Deactivate" : "Activate"} Campaign`}
        </Button>
      ),
    };
  };

  const fetchbonusCampaigns = async () => {
    setLoading(true);
    const allActivitiesApiRes = await getAllBonusActivities();
    const { status, data } = allActivitiesApiRes || {};
    setLoading(false);
    if (status === "SUCCESS") {
      setRows(data?.map((earnActivity) => dataGenerator(earnActivity)));
      return;
    }
    Swal.fire({
      title: "Oops",
      text: "Unable to fetch Campaigns, Please try again later!",
      icon: "warning",
      confirmButtonText: "Ok",
    });
  };

  useEffect(() => {
    fetchbonusCampaigns();
  }, []);
  return (
    <>
      <Box sx={{ px: 6 }} className={"main-box"}>
        <div className={"bankAddRuleHeader mb-3"}>
          <div
            style={{
              display: "flex",
              padding: "1.5rem 0",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "#33343a" }} variant="h4" component="h4">
              Bonus Campaign List
            </Typography>
            {loading && (
              <div
                style={{
                  marginLeft: "12px",
                  color: "#a0a0a0",
                  fontSize: "24px",
                }}
              >
                <i
                  className={`fa fa-refresh ${
                    loading === true ? "fa-spin" : ""
                  }`}
                  aria-hidden="true"
                ></i>
              </div>
            )}
          </div>
          <div style={{ display: "flex", alignItems: "end" }}>
            <TextField
              id="standard-basic"
              label="Search"
              variant="standard"
              sx={{ mr: 1 }}
              onKeyUp={(e) => searchData(e)}
              InputProps={{
                endAdornment: <SearchIcon sx={{ color: "#8a8a8a" }} />,
              }}
            />

            <Tooltip title="Choose Option">
              <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <MoreVertIcon sx={{ width: 32, height: 32 }} />
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem
                sx={{
                  "&:hover": {
                    background: "#f9da8792",
                    color: "#000",
                  },
                }}
              >
                <Link to="/app/bonus-campaign/0" style={{ color: "#040721" }}>
                  Add New Bonus Campaign
                </Link>
              </MenuItem>
            </Menu>
          </div>
        </div>

        <CustomTable
          data={filterList(rows, searchKey) || []}
          columns={columns}
        />
      </Box>
    </>
  );
};

export default BonusCampaignList;
